import { Header as HeaderVersion } from "../../config";
import HeaderV1 from "./v1";
import HeaderV2 from "./v2";

const versions = {
  v1: HeaderV1,
  v2: HeaderV2,
};

const Header = versions[HeaderVersion] || HeaderV1;

export default Header;
